{
  "header": {
    "nameVariable": {
      "id": "01fa65cd-a012-44d6-9297-8d44691cf891",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=258",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "d2ee0b95-f686-497a-8c20-28730a8c987a",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    },
    "file": ""
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "flatglass.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "b15a1091-4010-4719-87d1-6594ce4aad80",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=6038",
      "displayName": "Number",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "modellingRule": "Mandatory",
      "hasProperties": true,
      "hasUnit": false,
      "hasRange": false
    },
    "colorValues": {
      "NotAvailable": "#ff0000",
      "OutOfService": "#804040",
      "Executing": "#00ff00",
      "NotExecuting": "#ffff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "valueVariable": {
                "id": "d6837b4b-bae5-4a5f-bd02-71ddd1141162",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=182",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "id": "d6b618a2-0ac5-4746-9778-4d9cead71d30",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=258",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "valueVariable": {
                "id": "e40be8f5-7940-410f-ad25-c90e6aa9135a",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=259",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "valueVariable": {
                "id": "c8145fac-8977-4eb8-bba1-9b0a25b15201",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "valueVariable": {
                "id": "f8f0fefe-d3f2-49bc-ae40-eeeabba8b08a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "valueVariable": {
                "id": "ddc4aaca-9595-49c0-b3bc-e39c52f20131",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "valueVariable": {
                "id": "b5b7d4a8-097f-4c4f-8818-edb4a0a7e2de",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "valueVariable": {
                "id": "2890fa7a-5aa6-4579-b834-92597590b573",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "valueVariable": {
                "id": "416889bd-eec5-4470-9867-731c9e6141a9",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Machinery States",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "label": "Machinery Item State",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#000000",
                  "value": "NotAvailable",
                  "label": "Not Available"
                },
                {
                  "backgroundColor": "#804040",
                  "textColor": "#000000",
                  "value": "OutOfService",
                  "label": "Out Of Service"
                },
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#000000",
                  "value": "Executing"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "Not Executing"
                }
              ],
              "valueVariable": {
                "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6091",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            },
            {
              "type": 2,
              "label": "Machinery Operation Mode",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#0000ff",
                  "textColor": "#000000",
                  "value": "None",
                  "label": "None"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Maintenance",
                  "label": "Maintenance"
                },
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#000000",
                  "value": "Processing"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Setup"
                }
              ],
              "valueVariable": {
                "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
                "modelUri": "http://VDMA.org/OPCUACS_demonstrator/",
                "nodeId": "ns=1;i=6091",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryOperationMode.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Energy Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Total Active Power",
              "valueVariable": {
                "id": "82cc57d3-d35d-4467-9e50-4b0d1039f6ba",
                "modelUri": "http://opcfoundation.org/UA/ECM/",
                "nodeId": "nsu=http://opcfoundation.org/UA/ECM/;i=6068",
                "displayName": "AcActivePowerTotal",
                "variablePath": "MachineryBuildingBlocks.Monitoring.Consumption.Electricity.Main.<MeasurementValue>.AcActivePowerTotal",
                "dataType": "Float",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "W",
              "customRangeLow": 0,
              "customRangeHigh": 1000
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Imported Energy",
              "valueVariable": {
                "id": "4e9432d2-6929-43b0-adda-da919e8da8d2",
                "modelUri": "http://opcfoundation.org/UA/ECM/",
                "nodeId": "nsu=http://opcfoundation.org/UA/ECM/;i=6072",
                "displayName": "AcActiveEnergyTotalImportLp",
                "variablePath": "MachineryBuildingBlocks.Monitoring.Consumption.Electricity.Main.<MeasurementValue>.AcActiveEnergyTotalImportLp",
                "dataType": "Float",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "Wh"
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Exported Energy",
              "valueVariable": {
                "id": "581f7d50-d47c-4496-b796-11a361e66c8c",
                "modelUri": "http://opcfoundation.org/UA/ECM/",
                "nodeId": "nsu=http://opcfoundation.org/UA/ECM/;i=6076",
                "displayName": "AcActiveEnergyTotalExportLp",
                "variablePath": "MachineryBuildingBlocks.Monitoring.Consumption.Electricity.Main.<MeasurementValue>.AcActiveEnergyTotalExportLp",
                "dataType": "Float",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              },
              "customUnit": "Wh"
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Job Management",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 3,
              "isPlaceholder": false,
              "label": "",
              "columns": [
                {
                  "label": "JobOrderId",
                  "valueVariable": {
                    "id": "c59d494a-b3bc-40ec-aa67-c42f3fefcf83",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=31918",
                    "displayName": "JobOrderId",
                    "variablePath": "JobOrder.JobOrderID",
                    "dataType": "String",
                    "valueRank": -1,
                    "modellingRule": "Mandatory",
                    "hasProperties": false
                  }
                },
                {
                  "label": "Job State",
                  "valueVariable": {
                    "id": "d400c307-f639-426c-af22-b45ef5c2c07e",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=31918",
                    "displayName": "StateText",
                    "variablePath": "State[0].StateText",
                    "dataType": "LocalizedText",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false
                  }
                },
                {
                  "label": "Job State",
                  "valueVariable": {
                    "id": "d400c307-f639-426c-af22-b45ef5c2c07e",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=31918",
                    "displayName": "StateNumber",
                    "variablePath": "State[0].StateNumber",
                    "dataType": "String",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false
                  }
                }
              ],
              "rowPlaceholderObject": "MachineryBuildingBlocks.JobManagement.JobOrderControl.JobOrderList.[PLACEHOLDER]"
            }
          ],
          "title": "Jobs"
        }
      ]
    }
  ]
}
